import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { DEFAULT_STATE, STATE__API__FAIL, STATE__API__STARTED, STATE__API__SUCCESS } from '../../core/utils/store_utils';
import { invalidateToken } from '../authorization/get_token';
import webClient from '../../core/web_client';
import { buildQueryString, extractErrorData, extractResponseData } from '../../core/utils/api_utils';
import { PRODUCTS_AVAILABILITY_PATH } from '../../core/constants';

export const importProductAvailabilityAction = createAsyncThunk(
    'reservation/importProductAvailabilityAction',
    async (queryParams, { fulfillWithValue, rejectWithValue }) => {
        try {
            const response = await webClient.post(`${ PRODUCTS_AVAILABILITY_PATH }/copy${ buildQueryString(queryParams) }`);
            return fulfillWithValue(extractResponseData(response));
        } catch (error) {
            return rejectWithValue(extractErrorData(error));
        }
    }
);

const importProductAvailabilitySlice = createSlice({
    name: 'importProductAvailabilitySlice',
    initialState: DEFAULT_STATE,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(importProductAvailabilityAction.pending, () => STATE__API__STARTED);
        builder.addCase(importProductAvailabilityAction.fulfilled, (_, { payload }) => STATE__API__SUCCESS(payload));
        builder.addCase(importProductAvailabilityAction.rejected, (_, { payload }) => STATE__API__FAIL(payload));
        builder.addCase(invalidateToken, () => DEFAULT_STATE);
    }
});

export const importProductAvailabilityState = (state) => state.reservation.importProductAvailability;
export default importProductAvailabilitySlice.reducer;
